export const ogDefaultDescription =
  'La Mesa RV is one of the largest RV dealerships in the USA. See our inventory of high-quality motorhomes, travel trailers, fifth wheels & toy haulers today!';
export const ogDefaultTitle = 'Motorized RV Sale | RVs & Motorhomes For Sale | La Mesa RV | RecVan | La Mesa RV';

export const defaultDataTagGroup = 'page-components';
